import React from "react"
import {Button, Modal} from "react-bootstrap"

function ConfirmDelete(props: {
  title: string,
  show: boolean,
  confirm: () => void,
  onHide: () => void;
}) {
  const {title, show, confirm, onHide} = props;

  return (
    <Modal show={show}
           className="team-destroy"
           animation={false}
           onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            This cannot be undone
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row px-0">
          <div className="col text-right">
            <Button
              variant="secondary"
              className="ml-2"
              onClick={onHide}
              disabled={false}
            >Cancel</Button>
            <Button
              variant="primary"
              className="mx-4"
              onClick={confirm}
              disabled={false}>Delete</Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmDelete;
